import Tab from './Tab';
import TabGroup from './TabGroup';

export default { Tab, TabGroup };
export { Tab, TabGroup };



// WEBPACK FOOTER //
// ./src/reactis/reactis-tabs/src/index.js